$(document).ready(function () {
  if ($(".state-select").length) {

    setStateSelectionLink($(".state-select select"));

    $(".state-select select").change(function() {
      setStateSelectionLink($(this));
      $(".button-go").focus();
    });

    $(".state-select").keydown(function (e) {
      if (e.keyCode === 13 && $(".button-go").attr('href') !== "") {
        document.location = $(".button-go").attr('href');
      }
    });

  }
});

function setStateSelectionLink($this) {
  $(".button-go").attr("href", $this.find("option:selected").val());
}